module.exports = __webpack_public_path__ + "static/fonts/AvenirLTStdMedium.3714085.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/quiz-fonts/AvenirLTStdMedium.eot
// module id = 5T57
// module chunks = 1